import React from 'react';
import { Grid, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';
import { Trans } from '@gamiphy/react-i18n';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Close from '@mui/icons-material/Close';

type Props = {
  isBackButton: boolean,
  handleClick: () => void,
};

const DraftUserHeader: React.FC<Props> = observer(({ isBackButton, handleClick }) => {
  const isMobile = useMobile();
  const theme = useTheme();
  const ArrowIcon = React.useMemo(() => {
    if (theme.direction === 'rtl') {
      return <ArrowForward fontSize="large" />;
    }
    return <ArrowBack fontSize="large" />;
  }, [theme.direction]);

  return (
    <Grid
      container
      alignItems="center"
      sx={{
        py: 1,
        width: '100%',
        height: '100%',
        color: 'text.secondary',
      }}
    >
      {!isMobile && (
        <IconButton
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            color: 'text.secondary',
            '&:hover': {
              backgroundColor: 'rgba(225,225, 225, 0.3)',
            },
            backgroundColor: 'rgba(225, 225, 225, 0.1)',
          }}
          onClick={handleClick}
        >
          {isBackButton ? ArrowIcon : <Close fontSize="large" />}
        </IconButton>
      )}
      <Grid size={12}>
        <Typography variant="h6" component="h6" sx={{ fontSize: '21px', fontWeight: 600 }}>
          <Trans
            i18nKey="draft.user.hello"
            defaults="Hello there"
            values={{}}
          />
        </Typography>
      </Grid>
      <Grid size={12}>
        <Typography variant="subtitle1" sx={{ fontSize: '14px', fontWeight: 400 }}>
          <Trans
            i18nKey="draft.user.welcomeTo"
            defaults="Welcome to"
          />
          {' '}
          {AppStore.app.name}
        </Typography>
      </Grid>
    </Grid>
  );
});

export default DraftUserHeader;
